import { AutogenModelSalesStatus, AutogenRowSalesStatus } from "./autogen/AutogenModelSalesStatus";

export class ModelSalesStatus extends AutogenModelSalesStatus<RowSalesStatus> {
	constructor() {
		super(RowSalesStatus);
	}
}

export class RowSalesStatus extends AutogenRowSalesStatus {
}